import CommonButton from 'components/CommonButton/CommonButton';
import { FC } from 'react';
import { useLocation } from 'react-router-dom';
import { isInAdminPage } from 'utils/common';

interface ViewModeProps {
  isSortingEnabled: boolean;
  setIsSortingEnabled: React.Dispatch<React.SetStateAction<boolean>>;
  onDone: () => void;
  isSubmitting: boolean;
}

const ViewMode: FC<ViewModeProps> = ({
  isSortingEnabled,
  setIsSortingEnabled,
  onDone,
  isSubmitting,
}) => {
  const location = useLocation();
  const isRenderedInAdminPage = isInAdminPage(location);

  if (!isSortingEnabled) {
    return (
      <CommonButton
        variant={'secondary'}
        className={isRenderedInAdminPage ? '!min-h-[3.2rem]' : '!min-h-[4rem]'}
        onClick={() => setIsSortingEnabled(true)}
      >
        Sort Services
      </CommonButton>
    );
  }

  return (
    <CommonButton
      className={isRenderedInAdminPage ? '!min-h-[3.2rem]' : '!min-h-[4rem]'}
      onClick={onDone}
      isLoading={isSubmitting}
    >
      Done Sorting
    </CommonButton>
  );
};

export default ViewMode;
